import { bindActionCreators } from 'redux';
import {
  setColumns,
  setCustomFilters,
  setCurrentCustomFilters,
  setCustomActions,
  setCustomUpdates,
  reloadBucket,
} from '../../../actions/genericConsignmentActions';
import { getViewFieldConfig, TRIP_VIEW_TYPES } from './constants';

const getDisabledColumns = (
  viewType: string,
  bucket: string
) => {
  const disabled: string[] = [];
  if (TRIP_VIEW_TYPES.includes(viewType)) {
    disabled.push('organisation_reference_number');
  }
  if(viewType === 'tms_ist') {
    disabled.push('ist_reference_number');
  }
  if(viewType === 'tms_vehicle') {
    disabled.push('vehicle_number');
  }
  return disabled;
};

const getMinColumnLimit = (viewType: string) => {
  if(viewType === 'tms_ist') {
    return 2;
  }
  return 1;
};

export const getCustomColumnsModalStateProps = (
  masterData: any,
  viewType: string,
  bucket: string,
  ownProps: any = {}
) => {
  const fields = getViewFieldConfig(viewType);
  const fullFilterList = Array.isArray(
    masterData[fields.fullFilterList]?.[bucket]
  )
    ? masterData[fields.fullFilterList][bucket]
    : [];
  const filtersMetadata = Array.isArray(masterData[fields.filterMetadata])
    ? masterData[fields.filterMetadata]
    : [];

  return {
    maxColumnLimit: masterData.dashboard_fetch_max_column_limit || 20,
    columnsToShow:
      ownProps.columnsToShow ||
      masterData[fields.columnList]?.[bucket],
    fullColumnList:
      ownProps.fullColumnList ||
      masterData[fields.fullColumnList]?.[bucket],
    filtersToShow: Array.isArray(
      masterData[fields.filterList]?.[bucket]
    )
      ? masterData[fields.filterList][bucket]
      : [],
    fullFiltersMetadata: fullFilterList.map((ele: any) =>
      filtersMetadata.find((item: any) => item.id === ele)
    ),
    fullHeadersList: ownProps.fullHeadersList || [],
    headersToShow: ownProps.headersToShow || [],
    fullActionsList:
      ownProps.fullActionsList ||
      (Array.isArray(masterData.ops_full_actions_list_by_bucket?.[bucket])
        ? masterData.ops_full_actions_list_by_bucket[bucket]
        : []),
    actionsToShow:
      ownProps.actionsToShow ||
      (Array.isArray(masterData.ops_actions_list_by_bucket?.[bucket])
        ? masterData.ops_actions_list_by_bucket[bucket]
        : []),
    updatesToShow:
      ownProps.updatesList ||
      (Array.isArray(masterData[fields.updatesList]?.[bucket])
        ? masterData[fields.updatesList]?.[bucket]
        : []),
    updatesActive:
      ownProps.activeUpdatesList ||
      (Array.isArray(masterData[fields.activeUpdatesList]?.[bucket])
        ? masterData[fields.activeUpdatesList][bucket]
        : []),
    disabledColumns: getDisabledColumns(viewType, bucket),
    minColumnLimit: getMinColumnLimit(viewType),
  };
};

export const getCustomColumnsModalDispatchProps = (
  dispatch: any,
  viewType: string,
  bucket: string
) =>
  bindActionCreators(
    {
      setColumns: setColumns(viewType)(bucket),
      setCustomFilters: setCustomFilters(viewType)(bucket),
      setCurrentCustomFilters: setCurrentCustomFilters(viewType)(bucket),
      setCustomActions: setCustomActions(viewType)(bucket),
      setCustomUpdates: setCustomUpdates(viewType)(bucket),
      reloadBucket: reloadBucket(viewType)(bucket),
    },
    dispatch
  );
